import { memo } from "react";
import Svg, { Path, type SvgProps } from "react-native-svg";

const SvgClockOutline = (props: SvgProps) => (
  <Svg fill="none" height={24} width={24} {...props}>
    <Path
      d="M13 7a1 1 0 1 0-2 0v7a1 1 0 0 0 1.581.814l3.5-2.5a1 1 0 1 0-1.162-1.628L13 12.056z"
      fill={props.color}
    />
    <Path
      clipRule="evenodd"
      d="M24 12c0 6.627-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0s12 5.373 12 12m-2.18 0c0 5.423-4.397 9.82-9.82 9.82S2.18 17.423 2.18 12 6.577 2.18 12 2.18s9.82 4.397 9.82 9.82"
      fill={props.color}
      fillRule="evenodd"
    />
  </Svg>
);
const Memo = memo(SvgClockOutline);
export default Memo;
